export const signInFormName = "signInForm";
export const signUpFormName = "signUpForm";

export const USERNAME_FIELD_NAME = "username-1";
export const PASSWORD_FIELD_NAME = "password-1";
